import React from 'react';

function CancerClassifier() {
  return (
    <div className="container-fluid mt-4">
      <div className="text-center mb-4">
        <img
          src="/assets/images/projects/cancer_classifier/image1_700x300.svg"
          alt="Cancer Classifier Banner"
          className="img-fluid rounded shadow"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>
      <h2 className="mb-4">
        <i className="fas fa-brain text-primary"></i> Cancer Classifier (XAI)
      </h2>
      <div className="alert alert-info">
        <i className="fas fa-info-circle"></i> Clasificador de tumores cerebrales con inteligencia artificial explicable.
        Entrenado con <strong>EfficientNetV2</strong> (Accuracy: 0.9865).
      </div>
      <div className="embed-responsive" style={{ height: '80vh' }}>
        <iframe
          src="http://localhost:8501/"
          title="Cancer Classifier"
          className="embed-responsive-item w-100 h-100"
          style={{ border: '1px solid #ddd', borderRadius: '8px' }}
          allow="accelerometer; camera; microphone"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
        />
      </div>
    </div>
  );
}

export default CancerClassifier;
